<template>
    <Modal id="complete-waiver-modal"
           icon="fa-check-circle"
           :padded-boddy="true"
           :cancel="cancel"
           :ok-enabled="confirmed"
           :ok-spinner="submitting"
           :ok="ok"
           ok-label="COMPLETE_WAIVER_MODAL.OK__LABEL"
           size="sm"
           title="COMPLETE_WAIVER_MODAL.MODAL_TITLE">
        <form @submit.prevent="ok">
            <p>{{ l('COMPLETE_WAIVER_MODAL.INTRO') }}</p>

            <div class="form-v mt-2">
                <div class="form-group flex--align-center">
                    <label for="waiver-form-count"
                           class="control-label">
                        {{ l('COMPLETE_WAIVER_MODAL.FORM_COUNT__LABEL') }}
                    </label>

                    <StepperInput v-model="formCount"
                                  color="info"
                                  size="lg"
                                  :min="0" />
                </div>

                <div class="form-group">
                    <label class="control-label"
                           for="waiver-notes">{{ l('COMPLETE_WAIVER_MODAL.NOTES__LABEL') }}</label>
                    <textarea id="waiver-notes"
                              v-model="notes"
                              class="form-control input-lg"
                              style="min-height: 120px"
                              :placeholder="notesPlaceholder"></textarea>
                </div>

                <div class="form-group">
                    <label for="waiver-confirmed"
                           class="control-label">
                        {{ l('COMPLETE_WAIVER_MODAL.CONFIRM__LABEL') }}
                        <small class="required-label">{{ l('REQUIRED') }}</small>
                    </label>
                    <div class="form-group__checkboxes">
                        <label class="form-group__checkbox">
                            <input id="waiver-confirmed"
                                   v-model="confirmed"
                                   type="checkbox" />
                            {{ l('COMPLETE_WAIVER_MODAL.CONFIRM__TEXT') }}
                        </label>
                    </div>
                </div>
            </div>

            <div v-if="error"
                 class="alert alert-danger mt-1">
                <p>{{ error }}</p>
            </div>
        </form>
    </Modal>
</template>

<script>
import Modal from '@/vue/components/Modals/Modal';
import StepperInput from '@/vue/components/Forms/StepperInput';
import { container } from '@/container';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: { StepperInput, Modal },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        waiver: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            submitting: false,
            error: null,

            confirmed: false,
            formCount: 0,
            notes: '',
        };
    },

    computed: {
        notesPlaceholder() {
            return container.langService.getText('COMPLETE_WAIVER_MODAL.NOTES__PLACEHOLDER');
        },
    },

    methods: {
        ok() {
            if (this.submitting) {
                return;
            }

            this.error = null;
            this.submitting = true;

            container.waiversService
                .markWaiverCompleted(
                    this.waiver,
                    this.notes,
                    this.formCount,
                )
                .then((waiver) => {
                    this.resolve(waiver);
                })
                .catch((err) => {
                    this.error = err.message;
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
    },
};
</script>

<style lang="less">
@import (reference) "../../../../less/variables";

@media (min-width: @non-mobile-min) {
    .complete-waiver-modal {
        .stepper-input {
            width: 170px;
        }
    }
}
</style>
